import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useParams,
} from "react-router-dom";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";

import Auth from './components/auth.jsx';
import Home from './pages/home.jsx';
import Login from './pages/login.jsx';
import Register from './pages/register.jsx';
import DashboardPage from './pages/beachvision/DashboardPage.jsx';
import UploadPage from './pages/beachvision/UploadPage.jsx';
import SessionDetailPage from './pages/beachvision/SessionDetailPage.jsx';
import AnalysisResultsPage from './pages/beachvision/AnalysisResultsPage.jsx';
import TakeawayDetailPage from './pages/beachvision/TakeawayDetailPage.jsx';
import PointDetailPage from './pages/beachvision/PointDetailPage.jsx';
import HistoryPage from './pages/beachvision/HistoryPage.jsx';
import TrainingPage from './pages/beachvision/TrainingPage.jsx';
import AccountPage from './pages/beachvision/ProfilePage.jsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

function ScrollToTopOnNavigate() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

function AnalysisIndexRedirect() {
  const { id } = useParams();
  return <Navigate to={`/analysis/${id}/takeaways/`} replace />;
}

const App = (props) => (
  <QueryClientProvider client={queryClient}>
    <Router>
      <ScrollToTopOnNavigate />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#232B42",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.08)",
          },
        }}
      />
      <Auth {...props}>
        {
          (authProps) => {
            const nextParam = encodeURIComponent(
              `${authProps.location.pathname}${authProps.location.search}`,
            );
            const loginWithNext = `/login/?next=${nextParam}`;
            return (
            <Routes>
              <Route
                path="/"
                element={
                  authProps.authenticated ? (
                    <Navigate to="/dashboard/" replace />
                  ) : (
                    <Home {...authProps} />
                  )
                }
              />
              <Route path="/dashboard/" element={
                authProps.authenticated ? <DashboardPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/upload/" element={
                authProps.authenticated ? <UploadPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/sessions/:id/" element={
                authProps.authenticated ? <SessionDetailPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/analysis/:id/" element={
                authProps.authenticated ? <AnalysisIndexRedirect /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/analysis/:id/takeaways/" element={
                authProps.authenticated ? <AnalysisResultsPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/analysis/:id/strengths/" element={
                authProps.authenticated ? <AnalysisResultsPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/analysis/:id/points/" element={
                authProps.authenticated ? <AnalysisResultsPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/analysis/:id/takeaways/:tid/" element={
                authProps.authenticated ? <TakeawayDetailPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/analysis/:id/strengths/:tid/" element={
                authProps.authenticated ? <TakeawayDetailPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/analysis/:id/points/:pid/" element={
                authProps.authenticated ? <PointDetailPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/history/" element={
                authProps.authenticated ? <HistoryPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/training/" element={
                authProps.authenticated ? <TrainingPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/account/" element={
                authProps.authenticated ? <AccountPage {...authProps} /> : <Navigate to={loginWithNext} replace />
              } />
              <Route path="/profile/" element={<Navigate to="/account/" replace />} />
              <Route path="/login/" element={<Login {...authProps} />} />
              <Route path="/register/" element={<Register {...authProps} />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            );
          }
        }
      </Auth>
    </Router>
  </QueryClientProvider>
);

export default App;

